import { render, staticRenderFns } from "./settingRole.vue?vue&type=template&id=efeb85a6&"
import script from "./settingRole.vue?vue&type=script&lang=js&"
export * from "./settingRole.vue?vue&type=script&lang=js&"
import style0 from "./settingRole.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports